import { gsap } from "gsap";

export default function animationsInit() {

  if (document.querySelectorAll(".js-svg-circle-big").length) {
    gsap.to('.js-svg-circle-big', {
      y: 20,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });

  };

  if (document.querySelectorAll(".js-svg-circle-small").length) {
    gsap.to('.js-svg-circle-small', {
      y: 20,
      delay: 0.5,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

  if (document.querySelectorAll(".js-svg-circle-small-2").length) {
    gsap.to('.js-svg-circle-small-2', {
      y: -20,
      delay: 0.3,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

  if (document.querySelectorAll(".js-svg-circle-small-3").length) {
    gsap.to('.js-svg-circle-small-3', {
      y: 20,
      delay: 0.5,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

  if (document.querySelectorAll(".js-svg-circle-small-4").length) {
    gsap.to('.js-svg-circle-small-4', {
      y: -20,
      delay: 0.3,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

  if (document.querySelectorAll(".js-svg-circle-medium").length) {
    gsap.to('.js-svg-circle-medium', {
      y: -20,
      delay: 0.3,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

  if (document.querySelectorAll(".js-svg-megaphone").length) {
    gsap.to('.js-svg-megaphone', {
      rotate: '6deg',
      delay: 0.3,
      duration: 2,
      repeat: -1,
      yoyo: true,
      yoyoEase: true,
      ease: "sine.inOut",
    });
  };

}
